// The browser entry: mounts web chat and the Cockpit against the Application API on this origin.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createApi } from "./api.js";
import { App } from "./App.js";
// Hindi's Devanagari, served with the app rather than from a font CDN; Latin text keeps the Cockpit's font.
import "@fontsource/noto-sans-devanagari/devanagari-400.css";
import "@fontsource/noto-sans-devanagari/devanagari-500.css";
import "@fontsource/noto-sans-devanagari/devanagari-600.css";
import "@fontsource/noto-sans-devanagari/devanagari-700.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root");
createRoot(root).render(
  <StrictMode>
    <App api={createApi()} />
  </StrictMode>,
);
